module.exports = __webpack_public_path__ + "23df43a04f5d4537711959084d0dbc4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/members/dvorakova.jpg
// module id = 1242
// module chunks = 0